import { render, staticRenderFns } from "./PatientAuthDialog.vue?vue&type=template&id=03f8764a&"
import script from "./PatientAuthDialog.vue?vue&type=script&lang=js&"
export * from "./PatientAuthDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports